import {
  LayoutDashboard, FileText, ListTodo, UserCheck, ShieldCheck, BookOpen,
  BarChart3, History, Settings, ClipboardCheck, SlidersHorizontal, Network,
  PlugZap, HelpCircle, Rocket, GitBranch, FlaskConical, Gauge, ListTree,
} from "lucide-react";

// Navigation grouped into sections, with per-role visibility. Structured so
// real server-side RBAC can be layered on later without redesigning workflows.
export const NAV = [
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, path: "/", section: "Workspace",
    roles: ["provider", "intake", "reviewer", "executive", "admin"] },
  { id: "orders", label: "Orders", icon: FileText, path: "/orders", section: "Workspace",
    roles: ["provider", "intake", "reviewer", "executive", "admin"] },
  { id: "action_queue", label: "Action Queue", icon: ListTodo, path: "/action-queue", section: "Workspace",
    roles: ["provider", "intake", "reviewer", "admin"] },
  { id: "human_review", label: "Human Review", icon: UserCheck, path: "/human-review", section: "Workspace",
    roles: ["intake", "reviewer", "admin"] },

  { id: "defense_packets", label: "Evidence Packets", icon: ShieldCheck, path: "/defense-packets", section: "Evidence & Policy",
    roles: ["provider", "intake", "reviewer", "executive", "admin"] },
  { id: "policy_library", label: "Policy Library", icon: BookOpen, path: "/policy-library", section: "Evidence & Policy",
    roles: ["intake", "reviewer", "executive", "admin"] },
  { id: "rule_governance", label: "Rule Governance", icon: GitBranch, path: "/rule-governance", section: "Evidence & Policy",
    roles: ["intake", "reviewer", "executive", "admin"] },
  { id: "rules_harness", label: "Rules Test Harness", icon: FlaskConical, path: "/rules-harness", section: "Evidence & Policy",
    roles: ["reviewer", "executive", "admin"] },
  { id: "audit_trail", label: "Audit Trail", icon: History, path: "/audit", section: "Evidence & Policy",
    roles: ["intake", "reviewer", "executive", "admin"] },
  { id: "analytics", label: "Analytics", icon: BarChart3, path: "/analytics", section: "Evidence & Policy",
    roles: ["executive", "reviewer", "admin"] },

  { id: "pilot_config", label: "Pilot Configuration", icon: SlidersHorizontal, path: "/pilot-configuration", section: "Pilot Validation",
    roles: ["provider", "intake", "reviewer", "executive", "admin"] },
  { id: "operating_model", label: "Operating Model", icon: Network, path: "/operating-model", section: "Pilot Validation",
    roles: ["provider", "intake", "reviewer", "executive", "admin"] },
  { id: "integrations", label: "Integrations", icon: PlugZap, path: "/integrations", section: "Pilot Validation",
    roles: ["provider", "intake", "reviewer", "executive", "admin"] },
  { id: "domain_questions", label: "Domain Questions", icon: HelpCircle, path: "/domain-questions", section: "Pilot Validation",
    roles: ["provider", "intake", "reviewer", "executive", "admin"] },
  { id: "pilot_readiness", label: "Live Pilot Readiness", icon: Rocket, path: "/pilot-readiness", section: "Pilot Validation",
    roles: ["provider", "intake", "reviewer", "executive", "admin"] },
  { id: "pilot_measurement", label: "Pilot Measurement", icon: Gauge, path: "/pilot-measurement", section: "Pilot Validation",
    roles: ["provider", "intake", "reviewer", "executive", "admin"] },
  { id: "denial_taxonomy", label: "Denial Taxonomy", icon: ListTree, path: "/denial-taxonomy", section: "Pilot Validation",
    roles: ["provider", "intake", "reviewer", "executive", "admin"] },
  { id: "assumptions", label: "Assumptions & Dependencies", icon: ClipboardCheck, path: "/assumptions", section: "Pilot Validation",
    roles: ["reviewer", "executive", "admin"] },

  { id: "administration", label: "Administration", icon: Settings, path: "/administration", section: "System",
    roles: ["admin"] },
  { id: "validation_mode", label: "Validation Mode", icon: ClipboardCheck, path: "/validation", section: "System",
    roles: ["provider", "intake", "reviewer", "executive", "admin"] },
];

export const SECTION_ORDER = ["Workspace", "Evidence & Policy", "Pilot Validation", "System"];

export const navForRole = (role) => NAV.filter((n) => n.roles.includes(role));

export const can = {
  evaluate: (r) => ["provider", "intake", "admin"].includes(r),
  clarify: (r) => ["intake", "reviewer", "admin"].includes(r),
  respondClarify: (r) => ["provider", "intake", "admin"].includes(r),
  route: (r) => ["intake", "reviewer", "admin"].includes(r),
  resolveReview: (r) => ["reviewer", "admin"].includes(r),
  override: (r) => ["reviewer", "admin"].includes(r),
  markRisk: (r) => ["reviewer", "admin"].includes(r),
  release: (r) => ["intake", "reviewer", "admin"].includes(r),
  admin: (r) => r === "admin",
  createOrder: (r) => ["provider", "intake", "admin"].includes(r),
};
